import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setToken } from "./adminApi";
import { COLLECTIONS } from "./schemas";
import CollectionEditor from "./CollectionEditor";
import SettingsEditor from "./SettingsEditor";
import { useContent } from "../../context/ContentContext";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { refetch } = useContent();
  const [active, setActive] = useState(COLLECTIONS[0].key);

  const logout = () => {
    setToken(null);
    navigate("/admin/login", { replace: true });
  };

  const currentSchema = COLLECTIONS.find((c) => c.key === active);

  return (
    <div className="min-h-screen bg-canvas text-ink">
      <header className="border-b border-ink/10">
        <div className="mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="/brand/samurai-logo.png" alt="SAMURAI" className="h-6 w-auto object-contain" />
            <span className="text-[10px] tracking-[0.32em] uppercase text-ink/55">CMS</span>
          </div>
          <div className="flex items-center gap-6">
            <button
              onClick={async () => {
                await refetch();
                // Force reload public site to reflect latest content in another tab
              }}
              className="text-[10px] uppercase tracking-[0.3em] text-ink/70 hover:text-ink"
              data-testid="admin-refetch"
            >
              Refresh live site
            </button>
            <Link to="/" className="text-[10px] uppercase tracking-[0.3em] text-ink/70 hover:text-ink">
              View site ↗
            </Link>
            <button onClick={logout} className="text-[10px] uppercase tracking-[0.3em] text-ink/70 hover:text-ink" data-testid="admin-logout">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="mx-auto px-6 md:px-10 py-8 grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-10">
        <nav className="space-y-1" data-testid="admin-nav">
          {COLLECTIONS.map((c) => (
            <button
              key={c.key}
              onClick={() => setActive(c.key)}
              data-testid={`admin-nav-${c.key}`}
              className={`w-full text-left px-4 py-2 rounded text-[11px] uppercase tracking-[0.28em] transition-colors ${
                active === c.key
                  ? "bg-ink text-canvas"
                  : "text-ink/70 hover:text-ink hover:bg-ink/[0.05]"
              }`}
            >
              {c.label}
            </button>
          ))}
          <button
            onClick={() => setActive("__settings")}
            data-testid="admin-nav-settings"
            className={`w-full text-left px-4 py-2 rounded text-[11px] uppercase tracking-[0.28em] transition-colors ${
              active === "__settings"
                ? "bg-ink text-canvas"
                : "text-ink/70 hover:text-ink hover:bg-ink/[0.05]"
            }`}
          >
            Site Settings
          </button>
        </nav>

        <main>
          {active === "__settings" ? (
            <SettingsEditor />
          ) : (
            currentSchema && <CollectionEditor schema={currentSchema} />
          )}
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
